"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME_FRAME = exports.REFERENCE_DATE = exports.PRODUCT_CATEGORY = exports.MERGE_BUSINESS = exports.MERCHANT = exports.LAST_SEARCHED = exports.FULFILLMENT_LOCATION = exports.FULFILLER = exports.FILTER_PRECEDENCE = exports.FILTER_NAMES = exports.EXPECTED_SHIP_DATE = exports.CURRENCY = void 0;
// Names used here correspond to looker filters so don't modify them
var TIME_FRAME = {
  name: 'Select Timeframe',
  isClearable: false,
  isMulti: false,
  label: 'Time Frame',
  helpText: 'You can select a time frame.',
  options: [{
    value: 'week',
    label: 'Weeks'
  }, {
    value: 'month',
    label: 'Months'
  }, // { value: 'quarter', label: 'Quarters' },
  {
    value: 'year',
    label: 'Years'
  }]
};
exports.TIME_FRAME = TIME_FRAME;
var CURRENCY = {
  name: 'Select Currency',
  isClearable: false,
  isMulti: false,
  label: 'Currency',
  helpText: 'You can select a currency.',
  options: [{
    value: 'USD',
    label: 'USD'
  }, {
    value: 'EUR',
    label: 'EUR'
  }, {
    value: 'LOCAL',
    label: 'Local Currency'
  }]
};
exports.CURRENCY = CURRENCY;
var MERCHANT = {
  name: 'Merchant ID',
  isClearable: true,
  isMulti: true,
  label: 'Merchants',
  helpText: 'You can select multiple merchants.',
  options: [] // will be fetched and populated based on user access

};
exports.MERCHANT = MERCHANT;
var FULFILLER = {
  name: 'Fulfillername',
  isClearable: true,
  isMulti: true,
  label: 'Fulfillers',
  helpText: 'You can select multiple fulfillers.',
  options: [] // will be fetched and populated based on user access

};
exports.FULFILLER = FULFILLER;
var EXPECTED_SHIP_DATE = {
  name: 'Expected Ship Date',
  isClearable: true,
  options: ['Today', 'Tomorrow', 'This Week', 'This Month']
}; // pending implementation

exports.EXPECTED_SHIP_DATE = EXPECTED_SHIP_DATE;
var REFERENCE_DATE = {
  name: 'Select Reference Date'
};
exports.REFERENCE_DATE = REFERENCE_DATE;
var LAST_SEARCHED = 'last searched'; // configure merchants to be merged

exports.LAST_SEARCHED = LAST_SEARCHED;
var MERGE_BUSINESS = [{
  displayName: 'VCS',
  prefix: 'vcs'
}];
exports.MERGE_BUSINESS = MERGE_BUSINESS;
var PRODUCT_CATEGORY = {
  name: 'Enter Category ID',
  isClearable: true,
  isMulti: true,
  helpText: 'You can select multiple product categories.'
};
exports.PRODUCT_CATEGORY = PRODUCT_CATEGORY;
var FULFILLMENT_LOCATION = {
  name: 'Fulfillment Location ID',
  isClearable: true,
  isMulti: true,
  label: 'Fulfillment location',
  helpText: 'You can select multiple fulfillment locations.',
  options: [] // will be fetched and updaed based on user access

};
exports.FULFILLMENT_LOCATION = FULFILLMENT_LOCATION;
var FILTER_NAMES = {
  FULFILLER: FULFILLER.name,
  MERCHANT: MERCHANT.name,
  CURRENCY: CURRENCY.name,
  TIME_FRAME: TIME_FRAME.name,
  EXPECTED_SHIP_DATE: EXPECTED_SHIP_DATE.name,
  PRODUCT_CATEGORY: PRODUCT_CATEGORY.name,
  FULFILLMENT_LOCATION: FULFILLMENT_LOCATION.name
};
exports.FILTER_NAMES = FILTER_NAMES;
var FILTER_PRECEDENCE = {
  LAST: 'last',
  DEFAULT: 'default'
};
exports.FILTER_PRECEDENCE = FILTER_PRECEDENCE;